import { observer } from 'mobx-react';
import SchoolPartnerLogo from '../../../../../../../CurrentCollectionStep/BuilderV2/SchoolPartnerLogo';
import { ExperienceResource } from '../../../../../../../CurrentCollectionStep/BuilderV2/Types';

interface Props {
  experienceResource: ExperienceResource;
}

function ExperiencesHeaderLogo({ experienceResource }: Props) {
  return (
    <SchoolPartnerLogo
      height={38}
      name={experienceResource.payload.school_partner_name}
      links={experienceResource.links}
    />
  );
}

export default observer(ExperiencesHeaderLogo);
